import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../HandleAPICalls/actions";
import { ComboDetailsComponent, OrdersViewComp } from "./component";
import { toastr } from "react-redux-toastr";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

const ComboDetailsContainer = (props) => {
  const { comboId } = useParams();
  const [comboDetailsData, setComboDetailsData] = useState();
  const [loading, setLoading] = useState(true);
  const [showTableForRemoval, setShowTableForRemoval] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [cohortToRemove, setCohortToRemove] = useState("");

  const handleRemoveClick = () => {
    setShowTableForRemoval(true);
  };

  const handleCancelRemove = () => {
    setShowTableForRemoval(false);
  };

  const handleConfirmRemove = (cohort_id) => {
    if (cohort_id) {
      setCohortToRemove(cohort_id);
      setShowConfirmModal(true);
    } else {
      console.error("handleConfirmRemove received undefined cohortId");
    }
  };

  useEffect(() => {
    handleComboDetailsApi();
  }, []);

  useEffect(() => {
    if (cohortToRemove) {
      setShowConfirmModal(true);
    } else {
    }
  }, [cohortToRemove]);

  const confirmRemove = () => {
    if (!cohortToRemove) {
      return;
    }

    setLoading(true);
    const comboIdString = String(comboId);
    const cohortIdString = String(cohortToRemove);

    props.getDataFromAPI(
      `/partner/api/v2/combo/${comboIdString}/cohort/${cohortIdString}`,
      "DELETE",
      undefined,
      (response) => {
        setLoading(false);
        setShowConfirmModal(false);
        setCohortToRemove(null);
        handleComboDetailsApi();
      },
      (err) => {
        setLoading(false);
        toastr.error(`${err.message}`, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        });
      },
      true,
    );
  };

  const handleComboDetailsApi = () => {
    setLoading(true);

    return props.getDataFromAPI(
      `/partner/api/v2/combo/${comboId}`,
      "GET",
      undefined,
      (response) => {
        setLoading(false);
        setComboDetailsData(response);
      },
      (err) => {
        setLoading(false);
        toastr.error(`${err.message}`, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        });
      },
      true,
    );
  };

  return (
    <>
      <ComboDetailsComponent
        comboDetailsData={comboDetailsData}
        showTableForRemoval={showTableForRemoval}
        showConfirmModal={showConfirmModal}
        handleCancelRemove={handleCancelRemove}
        handleRemoveClick={handleRemoveClick}
        setShowConfirmModal={setShowConfirmModal}
        confirmRemove={confirmRemove}
        handleConfirmRemove={handleConfirmRemove}
      />
    </>
  );
};

function mapStateToProps({ props }) {
  return {
    props,
  };
}
export default connect(mapStateToProps, {
  getDataFromAPI,
})(ComboDetailsContainer);
